import type {RouteWithParams} from '../routing.types';
import getRouteWithParamsFromUrl from './getRouteWithParamsFromUrl';

function getCurrentRouteWithParams(): RouteWithParams | null {
  return getRouteWithParamsFromUrl(window.location.pathname + window.location.search);
}

export default getCurrentRouteWithParams;
